import { MeasurementsLayer } from "./MeasurementsLayer.js";
import { DwsLoader, DWS_DEFAULT_URL } from "../../data/DwsLoader.js";

export { DwsLayer }

/**
 * Layer for displaying Data from the DWS in the viewer
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.map.layer
 */
class DwsLayer extends MeasurementsLayer {

    /**
     * Set all properties for the layer based on the options object.
     * 
     * @param {object} config 
     * @param {object} cache 
     * @param {string} id 
     */
    constructor(config, cache, id) {
        // calling parent constructor
        super(config, cache, id);

        // init default values and define getters and setters
        this.addDefaults_({
            // overwrite defaults
            defaultXAxis: "datetime",
            defaultYAxis: this.columnData,
            limit: 10000,
            sensorMetadata: {},
            aggregate: "HOUR",
            url: ""
        });

        this.setAll_("type", "dws");

        this.dwsLoader_ = new DwsLoader(this.url);

        this.fetchMetadata_();
    }

    fetchMetadata_() {
        const url = this.url || DWS_DEFAULT_URL;
        fetch(url + "/search", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hits: 1,
                query: 'metadata.code:("' + this.columnData + '")',
                sorts: [],
                indices: [],
                offset: 0,
                queryFacets: {},
                types: []
            })
        })
            .then(respone => respone.json())
            .then(json => {
                if (json.records && json.records.length) {
                    const record = json.records[0];

                    this.abstract = record.description || "";
                    this.sensorMetadata = Object.assign(this.sensorMetadata, record)
                }
            });
    }

    /**
     * Set the colorscale for the layer
     * 
     * @param colorScale 
     * @override
     */
    setColorScale(colorScale) {
        this.colorScale = colorScale;

        if (!(this.activeMap_ in this.mapLayers_)) return;

        switch (this.activeMap_) {
            case "leaflet":
                this.mapLayers_.leaflet.eachLayer(layer => {
                    for (let property in layer.feature.properties) {
                        if ((property == this.columnData) || (property.split(" ")[0] == this.columnData)) {
                            const value = layer.feature.properties[property];
                            const style = this.getColorOptions_(value);
                            layer.setStyle(style)
                            break;
                        }
                    }
                });
                break;
        }
    }

    /**
     * Loads data of the dws filtered by time
     * @private
     */
    applyFilter_() {
        let beginDate, endDate;

        for (let i = 0; i < this.filter.length; ++i) {
            if ((this.filter[i].type == "time") && (this.filter[i].values.length > 0)) {
                const values = this.filter[i].values[0];
                if ((values.length == 3) && (values[0] == "bt")) {
                    beginDate = values[1].substr(0, 19);
                    endDate = values[2].substr(0, 19);
                }
            }
        }

        // fallback: today - 30 days
        if (!beginDate || !endDate) {
            const tempDate = new Date();
            endDate = tempDate.toISOString().substr(0, 19);
            tempDate.setMonth(tempDate.getMonth() - 1);
            beginDate = tempDate.toISOString().substr(0, 19);
        }

        return new Promise(resolve => {
            this.dwsLoader_.data([this.columnData, this.columnLatitude, this.columnLongitude], beginDate, endDate, this.limit || 10000, this.aggregate || "HOUR").then(df => {
                this.dataFrameOriginal = df;
                this.dataFrame = df;
                resolve(df);
            });
        });
    }

}